import { Component, Vue, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { setSchool, setSchoolById ,getSchoolList,delSchoolByIdList,schoolExportData } from '@/api/common'
import { formatDate } from '@/utils/timeFilter'
import { menuBtn } from '@/utils/menu_level2_button'
import { delNullProperty } from '@/utils/index'
import realTimeSokcet from '@/utils/socket.io'

@Component({})
export default class SchoolList extends Vue {
    socket: any = null
    tableHeadPopoverShow = false
    tableData: any= []
    tableHeader: any = []
    checkTableRow: any = []
    tableHeadFilter = {
        name: '',
        types: ''
    }
    page = 1
    limit = 20
    total = 0
    selfTotal = 0
    // tableRandom = Math.random()
    addDialog = false
    sendBackSelect = ''
    schoolName = ''
    schoolTypesList = [
        { value: '0', name: '海外大学' },
        { value: '1', name: '国内大学' },
        { value: '2', name: '中学' }
    ]
    schoolType = ''
    loading = false
    sendBackClueID: number; // 退户线索id
    menuBtn = menuBtn
    deteleDialog = false
    cancelTabkBackClueId: number
    sendBackDialogConfirmButtonDisabled = false
    rowData = null
    delType: any = null
    repeatName: any =null
    uploadUrl: any = null
    uploadDialog = false
    uploadData = null
    exportButtonDisabled = false
    timer = null


    // computed
    get userId() {
        return UserModule.userId
    }

    // created
    created() {
        this.getTableData()
        if(process.env.NODE_ENV === 'development') {
            this.uploadUrl = process.env.VUE_APP_BASE_CRM_API_PROXY + '/tools/importSchool'
        } else {
            if(window.location.origin.includes('-testserver')) {
                this.uploadUrl = process.env.VUE_APP_DEV_API + '/tools/importSchool'
            } else {
                this.uploadUrl = process.env.VUE_APP_MASTER_API + '/tools/importSchool'
            }
        }
    //     intentionalityOptions = ['高', '中', '低', '暂无', '已签约', '已拒绝']
    // intentionalityName: ''
    }

    // updated(){
    //     this.$nextTick(() => {
    //         this.initSocket()
    //     })
    // }

    destroyed() {
        // this.socket.disconnect()
    }

    // methods
    // async getTableHeader() {
    //     this.loading = true
    //     const data: any = await gettHeaderByType(3)
    //     this.tableHeader = data.headerUserList
    //     this.loading = false
    //     this.getTableData()
    // }
    getRowKeys (row: any) {
        return row.id
    }

    async getTableData() {
        this.loading = true

        const obj = { ...this.tableHeadFilter, page: this.page, limit: this.limit }
        const data: any = await getSchoolList(delNullProperty(obj))
        this.tableData = data.schoolList
        this.total = data.allNum
        // this.tableRandom = Math.random()
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
        });
        this.loading = false
        // this.isReadonly = false
    }

    handleSelectionChange(arr: any) {
        this.checkTableRow = arr
    }
    openDtatisticsData() {
        window.open(window.location.origin + this.$route.matched[0].path + '/transfromCustomerStatisticsData')
    }
    async exportExcel() {
        this.exportButtonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        const obj = this.removePropertyOfNull({ ...this.tableHeadFilter, page: this.page, limit: this.limit })
        for(const key in obj) {
            if(obj[key].length == 0 || !obj[key]) {
                delete obj[key]
            }
        }
        if(obj.lastFollowAt) obj.lastFollowAt = formatDate('yyyy-MM-dd', new Date(obj.lastFollowAt[0])) + '/' + formatDate('yyyy-MM-dd', new Date(obj.lastFollowAt[1]))
        schoolExportData(obj).finally(() => {
            this.exportButtonDisabled = false
        })
    }
    uploadprogress() {
        this.loading = true
    }
    // 批量导入
    async handleModifySuccess (response: any) {
        if (response.error.returnCode === 0) {
        this.page = 1
        this.uploadDialog = true
        this.uploadData = response.data
        await this.getTableData()
        } else {
        this.$message({
            type: 'error',
            message: response.error.returnMessage
        })
        }
        const upload: any = this.$refs.upload
        upload.clearFiles()
        this.loading = false
    }

    async handleModifyError () {
        this.$message({
        type: 'error',
        message: '导入失败!'
        })
        const upload: any = this.$refs.upload
        upload.clearFiles()
    }

    uploadExcel() {
        const url = this.uploadData.ossUrl
        const a: any = document.createElement('a')
        a.href = url
        a.click()
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }
    ClickTableRow(row: any, col: any) {
        if (!this.menuBtn(34)) return
        if (col.label !== '操作' && row.isReceive === 1) {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/transfromCustomerInfo?id=' + row.id)
            const time = setInterval(() => {
                if(win.closed) {
                    this.getTableData()
                    clearInterval(time)
                }
            }, 500)
        }
    }
    clickFinanceOrderCount(row: any) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/studentDetail?id=' + row.id)
            const time = setInterval(() => {
                if(win.closed) {
                    this.getTableData()
                    clearInterval(time)
                }
            }, 500)
    }

    initSocket() {
        const time = setInterval(() => {
            if(Vue.prototype.$socket.on) {
                realTimeSokcet(this.userId, 'MarketClue', this.getTableData)
                clearInterval(time)
            }
        }, 100)
    }
    editSchool(row: any) {
        this.rowData = row
        this.schoolName = row.name
        this.schoolType = this.schoolTypesList.find(item=>item.name === row.types).value
        this.addDialog = true
    }
    deleteSchool(row: any,type: any) {
        this.delType = type
        this.rowData = row
        this.deteleDialog = true
    }
    deleteSchool1(type: any) {
        this.delType = type
        this.deteleDialog = true
    }
    async confirmSchool() {

        if (!this.schoolName) {
            this.$message.error('学校名字不能为空')
            return;
        }
        if (!this.schoolType) {
            this.$message.error('学校类型不能为空')
            return;
        }

        if(this.rowData) {
            await setSchoolById({name: this.schoolName, types: this.schoolType, id: this.rowData.id})
            this.$message.success('编辑学校成功')
            this.schoolName = ''
            this.schoolType = ''
            this.getTableData()
            this.addDialog = false
        } else {
            await setSchool({name: this.schoolName, types: this.schoolType})
            this.$message.success('新建学校成功')
            this.getTableData()
            this.schoolName = ''
            this.schoolType = ''
            this.addDialog = false
        }

    }
    addSchool() {
        this.rowData = null
        this.addDialog = true
    }
    async confirmCancelTakeBackClue() {
        let list: any = []
        if(this.delType ===2 ) { // 单独删除
            list = [ this.rowData.id ]
            await delSchoolByIdList({ idList: list })
        } else { // 批量删除
            list = this.checkTableRow.map(item=>item.id)
            await delSchoolByIdList({ idList: list })
        }
        this.rowData = null
        this.$message.success('删除成功')
        this.getTableData()
        this.deteleDialog = false
    }

    removePropertyOfNull(object: any) {
        const obj = JSON.parse(JSON.stringify(object))
        Object.keys(obj).forEach(item => {
            if ((obj[item] === '' || !obj[item] || obj[item].length === 0) && obj[item] !== 0) {
                delete obj[item]
            }
        })
        return obj;
    }



    @Watch('userId')
    handleWatchUserId() {
        this.initSocket()
    }
}
